// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1NEFh","detailsBorder":"styles_detailsBorder__zbzUp"};